/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step1_BodyInputs */

const es_landing_step1_body = /** @type {(inputs: Landing_Step1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creas el anuncio de tu barco y pagas la tasa única de 100€. Con eso firmamos el contrato de gestión y arrancamos.`)
};

const gl_landing_step1_body = /** @type {(inputs: Landing_Step1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creas o anuncio do teu barco e pagas a tasa única de 100€. Con iso asinamos o contrato de xestión e arrancamos.`)
};

const en_landing_step1_body = /** @type {(inputs: Landing_Step1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your boat listing and pay the one-off €100 fee. That signs the management contract and gets things moving.`)
};

/**
* | output |
* | --- |
* | "Create your boat listing and pay the one-off €100 fee. That signs the management contract and gets things moving." |
*
* @param {Landing_Step1_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_step1_body = /** @type {((inputs?: Landing_Step1_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step1_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_step1_body(inputs)
	if (locale === "en") return en_landing_step1_body(inputs)
	return es_landing_step1_body(inputs)
});